import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimEntitlementAutoTopUpEventCompanyFilterContainerModel
} from '../../../../../../models';


@Injectable({
  providedIn: 'root'
})
export class ClaimEntitlementAutoTopUpEventCompanyFilterService extends BaseApiTemplateService<ClaimEntitlementAutoTopUpEventCompanyFilterContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
    Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/filter-companies/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/filter-companies/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/filter-companies/backoffice-ep';
    this.httpClient = http;
  }

}


